<template>
  <div class="analysis-tabs">
    <div class="tabs-header">
      <div class="tabs-list">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="tab-button"
          :class="{ active: activeTab === tab.id }"
          @click="setActiveTab(tab.id)"
        >
          {{ tab.label }}
        </button>
      </div>
    </div>

    <div class="tabs-content">
      <slot :activeTab="activeTab" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  defaultTab: {
    type: String,
    default: 'overview'
  }
});

const emit = defineEmits(['tabChanged']);

const tabs = [
  { id: 'overview', label: 'Overview' },
  { id: 'valuation', label: 'Valuation' },
  { id: 'technicals', label: 'Technicals' },
  { id: 'portfolio', label: 'Portfolio Impact' }
];

const activeTab = ref(props.defaultTab);

const setActiveTab = (tabId) => {
  activeTab.value = tabId;
  emit('tabChanged', tabId);
};
</script>

<style scoped>
.analysis-tabs {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.tabs-header {
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.tabs-list {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tabs-list::-webkit-scrollbar {
  display: none;
}

.tab-button {
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  position: relative;
}

.tab-button:hover {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.05);
}

.tab-button.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
  background: #fff;
}

.tabs-content {
  padding: 12px;
  min-height: 300px;
}

@media (max-width: 768px) {
  .tab-button {
    padding: 8px 12px;
    font-size: 0.75rem;
  }

  .tabs-content {
    padding: 10px;
  }
}
</style>
